import { render } from "./PublicHolidays.vue?vue&type=template&id=298712ae&scoped=true"
import script from "./PublicHolidays.vue?vue&type=script&lang=js"
export * from "./PublicHolidays.vue?vue&type=script&lang=js"

import "./PublicHolidays.vue?vue&type=style&index=0&id=298712ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298712ae"]])

export default __exports__